export enum AlertTypes {
  NOTIFICATION = "notification",
  BASE = "base",
}
